/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetAbExperimentsModel,
  IGetAbExperimentsRequest,
  IMappers,
  IGetAbExperimentsResponse,
  IGetAbExperimentsResponseError,
  TGetAbExperimentsResponse,
} from './types';

const defaultConfig: TGetAbExperimentsModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/get-ab-experiments/',
  hostType: 'api',
} as TGetAbExperimentsModel;

function createGetAbExperimentsModel(parameters: IGetAbExperimentsRequest): TGetAbExperimentsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetAbExperimentsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetAbExperimentsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetAbExperiments<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetAbExperimentsOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetAbExperimentsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetAbExperimentsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAbExperimentsResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetAbExperimentsResponseError);
    }
  }

  return { response, statusCode } as TGetAbExperimentsResponse;
}

export { defaultConfig, createGetAbExperimentsModel, fetchGetAbExperiments };
